import type { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box } from '@atlaskit/primitives';
import { useToken } from '../../../../components/Flow/ConsentContextProvider';

const headers = defineMessages({
  header: {
    id: 'trello.nonpermissions.header',
    defaultMessage: '{appName} will not be able to',
    description: 'Header describing permissions',
  },
});

const messages = defineMessages({
  bulletOne: {
    id: 'trello.nonpermissions.bulletOne',
    defaultMessage: 'See your Trello password',
    description: 'Bullet describing non-permissions',
  },
});

const messagesArray = Object.values(messages);

const NonPermissionsBullets: FunctionComponent = () => {
  const { clientName } = useToken();
  return (
    <Box>
      <FormattedMessage
        {...headers.header}
        values={{
          appName: <strong>{clientName}</strong>,
        }}
      />
      <ul>
        {messagesArray.map((message) => (
          <li key={message.id}>
            <FormattedMessage {...message} />
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default NonPermissionsBullets;
